<template>
  <div> 
    <h2 class="titulo" style="color: #882821">
          <img
            src="https://www.lefrank.com.br/img/icons/Image%20787.png"
            height="19px"
            title="Registro no Le Frank"
            alt="Registro no Le Frank"
          />
          Destaques
        </h2>
        <section id="destaques">
          <section v-for="fixo in json" v-bind:key="fixo.id" class="card" v-bind:style="{ 'background-image': 'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.8) 100%), url(' + fixo.img + ')' }">
          <router-link :to="{path: '/artigo/' + fixo.id}">  
            <section class="conteudo">
              <section class="resumo">
                <p>
                  {{ fixo.titulo }}
                </p>
                <span>
                  {{ fixo.descricao }}
                </span>
              </section>
              <li>{{ fixo.autor }}</li>
              <li style="float: right">{{ fixo.views }} <img src="//lefrank.com.br/img/icons/new_19.gif" width="7px"></li>
            </section>
          </router-link>
          </section>
          <section class="espaco-card"></section>
        </section>
  </div>
</template>

<script>

export default {
  name: "Destaques",
  data: () => ({
    json: {}
  }),
  created: function() {
    fetch('https://api.lefrank.com.br/artigos?fixo=sim').then((response) => {
      return response.json().then((json) => {
        this.json = json
      })
    })
  }
};
</script>

<style scoped>

#destaques {
  display: flex;
  width: 100%;
  height: 365px;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
  font-family: 'Krub', sans-serif;
  font-weight: 600;
}

#destaques .card {
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  margin: 10px 5px;
  padding: 10px;
  min-width: 280px;
  max-width: 280px;
  height: 333px;
  background-color: rgba(0,0,0,0.2);
  display: inline-block;
}

#destaques .card:first-child {
  margin-left: 10px;
}

#destaques .card:last-child {
  margin-right: 10px;
}

#destaques .card .conteudo {
  margin: 0 auto;
  width: inherit;
  height: inherit;
  float: left;
}

#destaques .card .conteudo .resumo {
  width: inherit;
  height: 155px;
}

#destaques .card .conteudo .resumo p {
  font-size: 1rem;
  width: inherit;
  font-weight: 700;
  color: white;
  margin: 0;
  padding: 7px 7px 0 7px;
  float: left;
}

#destaques .card .conteudo .resumo span {
  font-size: 0.875rem;
  width: inherit;
  font-weight: 300;
  color: white;
  margin: 0;
  padding: 0 7px;
  float: left;
}

#destaques .card .conteudo li {
  list-style-type: none;
  padding: 3px 7px;
  font-size: 0.8125rem;
  color: white;
  font-weight: 600;
  float: left;
  margin-top: 155px;
  background-color: #882821;
  box-shadow: 0 1px 1px rgba(0,0,0,0.4);
  border-radius: 5px;
  
}
</style>
